import { TRIGGER_LOCATIONS } from '../../../constants/ClickstreamConstants';

const TRIGGER_LOCATIONS_MAP = {
  relisting: TRIGGER_LOCATIONS.POSTING_PATH_REVIEW,
  posting_path: TRIGGER_LOCATIONS.POSTING_PATH,
  posting_path_review: TRIGGER_LOCATIONS.POSTING_PATH_REVIEW,
} as const;

export { TRIGGER_LOCATIONS_MAP };
